import { Send1 } from 'blaze-ui/icons'
import { useSecretIdentity } from 'components/SecretIdentity/Provider'
import { useEffect, useRef } from 'react'
import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'

export const ShareButton = ({ size = 'md', ...buttonProps }: Pick<ButtonProps, 'size' | 'fullWidth' | 'variant'>) => {
  const { file } = useSecretIdentity()
  const shareButtonRef = useRef<HTMLButtonElement>(null)

  // the share api requires a user gesture to work, and react-aria's onPress doesn't count
  // so we have to add an event listener to the button and call the share function directly
  useEffect(() => {
    const handleShare = () => {
      if (!file) return

      const shareData = {
        title: 'I just signed up for Blaze! Check out my  superpower\nhttps://blaze.ai',
        files: [file],
      }
      trackEventInHeap(HeapEventType.Onboarding, { action: 'share-secret-identity' })
      navigator.share(shareData)
    }

    const btn = shareButtonRef.current

    if (btn) {
      btn.addEventListener('click', handleShare)

      return () => {
        btn.removeEventListener('click', handleShare)
      }
    }
  }, [file])

  return (
    <Button
      size={size}
      variant="secondary"
      frontIcon={Send1}
      ref={shareButtonRef}
      isDisabled={!file || typeof navigator.canShare !== 'function' || !navigator.canShare({ files: [file] })}
      aria-label="Share"
      {...buttonProps}
    >
      Share
    </Button>
  )
}
